import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-funds-box-line',
      title: 'Cash Flow Coach',
      description: 'A user-friendly cash flow forecast model that\'s supported by your dedicated Cash Flow Coach to keep your business solvent.',
      gradient: 'from-orange-500 to-amber-500'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Turnaround Services',
      description: 'Cost-effective turnarounds built on a highly structured approach, so you always know what to expect.',
      gradient: 'from-amber-500 to-yellow-500'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Cost Reduction',
      description: 'Streamlining operations by cutting unnecessary expenditures, rightsizing your workforce, and building leaner, more resilient supply chains.',
      gradient: 'from-yellow-500 to-orange-600'
    },
    {
      icon: 'ri-robot-line',
      title: 'Process Automation',
      description: 'Modernizing your operations through smart technology upgrades and AI-driven solutions that eliminate bottlenecks, reduce manual effort, and unlock new levels of efficiency.',
      gradient: 'from-orange-600 to-red-500'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Capital Solutions',
      description: 'We represent you in communicating with lenders to determine the best financial decisions for your unique situation and secure the capital your business needs.',
      gradient: 'from-red-500 to-rose-500'
    },
    {
      icon: 'ri-user-star-line',
      title: 'CXO Services',
      description: 'Financial information building and financial reporting designed for the pace of insolvency matters — interim CFO, CEO, and COO services when you need them.',
      gradient: 'from-rose-500 to-orange-500'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-slate-900 mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive turnaround and restructuring solutions designed to stabilize, recover, and grow distressed businesses
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-serif font-bold text-slate-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
              <Link to="/services" className="inline-flex items-center text-orange-600 font-semibold hover:gap-2 transition-all cursor-pointer">
                Learn More
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}